import React from 'react'
import AssetInputOrUploadSection from './AssetInputOrUploadSection'
import { CREATIVE_ASSET_TYPES, CREATIVE_NAMES, MOBILE_STICKY_VIDEO_AD_FIELDS } from './definitions'
import BaseCreativeControls from './BaseCreativeControls'
import VideoAssetCreativeType from './VideoAssetCreativeType'

const CREATIVE_TYPE = CREATIVE_NAMES.MOBILE_STICKY_VIDEO

export default function MobileStickyVideo({
    bannerUrl,
    videoCreativeUrl,
    handleChange,
    currentCustomer,
    impressionTag,
    clickTag,
    adServingType,
    videoCreativeType,
    vastUrl,
    vastDuration
}) {
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
            >
                <AssetInputOrUploadSection
                    inputValue={bannerUrl}
                    inputLabel='Static banner URL'
                    inputName={MOBILE_STICKY_VIDEO_AD_FIELDS.bannerUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                <VideoAssetCreativeType
                    dropdownLabel="Video Creative Type"
                    types={CREATIVE_ASSET_TYPES}
                    videoCreativeTypePropertyName={MOBILE_STICKY_VIDEO_AD_FIELDS.videoCreativeType}
                    videoCreativeType={videoCreativeType}
                    handleChange={handleChange}
                    CREATIVE_TYPE={CREATIVE_TYPE}
                    currentCustomer={currentCustomer}
                    videoUrlInputLabel="Video URL"
                    videoUrlInputName={MOBILE_STICKY_VIDEO_AD_FIELDS.videoCreativeUrl}
                    videoUrl={videoCreativeUrl}
                    vastUrl={vastUrl}
                    vastInputName={MOBILE_STICKY_VIDEO_AD_FIELDS.vastUrl}
                    vastDurationInputName={MOBILE_STICKY_VIDEO_AD_FIELDS.vastDuration}
                    vastDuration={vastDuration}
                />
                
            </BaseCreativeControls>

        </>
    )
}